import React, { useCallback, useMemo } from 'react'
import { Row, Col, Label } from 'reactstrap'
import { Icon } from 'components/icons'
import { useStyles } from './index.css'
import MuiButton from '@material-ui/core/Button'
import { WineEvaluationItem } from './item'

export const WineEvaluations = (props) => {
  const classes = useStyles()

  const { localize, updateEntity, entity, disabled, isInDialog } = props
  const { wineEvaluations } = entity

  const handleAddClick = useCallback(() => {
    const newEvaluations = [...wineEvaluations, { evaluator: null, evaluation: 0 }]
    updateEntity('wineEvaluations')(newEvaluations)
  }, [updateEntity, wineEvaluations])

  const handleUpdate = useCallback(({ wineEvaluation, index }) => {
    const newItems = wineEvaluations.map((x, idx) => idx === index ? wineEvaluation : x).filter(x => x)
    updateEntity('wineEvaluations')(newItems)
  }, [updateEntity, wineEvaluations])

  const addButtonDisabled = useMemo(() => wineEvaluations.length >= 4 || disabled, [wineEvaluations, disabled])
  return (
    <div className={classes.root}>
      <Row>
        <Col sm={12}>
          <Label>{localize('wines.wineEvaluations')}</Label>
          <div className={classes.addButton}>
            <MuiButton
              className={classes.button}
              variant='contained'
              disabled={addButtonDisabled}
              title={localize('wines.addWineEvaluation')}
              color='primary'
              onClick={handleAddClick}><Icon name={'plus'} /></MuiButton>
          </div>
        </Col>
      </Row>
      <Row>
        {entity.wineEvaluations.map((x, idx) => 
          <WineEvaluationItem 
            key={`item_${idx}`} 
            wineEvaluation={x} 
            localize={localize} 
            index={idx} 
            onUpdate={handleUpdate} 
            canRemove={idx === entity.wineEvaluations.length - 1}
            disabled={disabled}
            isInDialog={isInDialog}
          />)}
      </Row>
    </div>
  )
}
